import * as React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Bs4UxTemplates, getUxTemplate, UxAccordion, useStateUxTemplate } from '../Bs4UxTemplates';
import Bs4I18N from '../../Bs4I18N';


export class Bs4ReportCalendarPlanningUx {
  static BS4UXTEMPLATES_UXMAINID = 'Bs4UxTemplates_uxMainId'
  static TYPE_BS4_THEME = 'type_bs4_theme';
  static TYPE_APPBAR = 'type_AppBar';
  static TYPE_INCOMING = 'type_Incoming';
  static TYPE_VERTICALMENU = 'type_VerticalMenu'
  static TYPE_VERTICALMENU_OPTIONS = 'type_VerticalMenu_options'
  static TYPE_A_LINK = 'type_a_link'

  setUxTemplate = (id) => {    
    if (!id) id = window.localStorage.getItem(Bs4ReportCalendarPlanningUx.BS4UXTEMPLATES_UXMAINID);
    this.uxTemplate = getUxTemplate(this.defaultUxTemplate, 0, id, 'Main');
  }

  defaultUxTemplate = {
    class: 0,
    name: 'Bs4Main',
    body: {
      main: true,
      Main: {
        theme: {},
      },
      Link: {
        a: {},
        link: {},
        hover: {},
        visited: {},
      },
      AppBar: {
        box: {},    
        logo: {},
        incoming: {},
      },  
      VerticalMenu: {
        divider: null,
        box: {          
          padding: 0.5, 
        },
        text: {
          main:     0.5,
          hover:    0.9,
          selected: 1.0,
        },
        scrollbar: {
          width:                  8,
          trackBorderRadius:     '99px',
          trackBackground:       'transparent',
          trackBackgroundHover:  '#ffffff77',
          thumbBackground:       '#ffffff77',
          thumbBackgroundHover:  '#ffffff99',
        },
      },
      VerticalMenuOptions: {
        divider: null,
        box: {          
          padding: 0.5, 
        },
        text: {
          main:     0.5,
          hover:    0.9,
          selected: 1.0,
        },
        scrollbar: {
          width:                  8,
          trackBorderRadius:     '99px',
          trackBackground:       'transparent',
          trackBackgroundHover:  '#ffffff77',
          thumbBackground:       '#ffffff77',
          thumbBackgroundHover:  '#ffffff99',
        },
      },
    },
  };

  getUxTemplateEditor = (uxEditor) => {        
    const eds = [
      this.getUxTemplateEditorMain(uxEditor),
      this.getUxTemplateEditorBs4AppBar(uxEditor),
      this.getUxTemplateEditorBs4Incoming(uxEditor),
      this.getUxTemplateEditorBs4VerticalMenu(uxEditor),
      this.getUxTemplateEditorBs4VerticalMenuOptions(uxEditor),
      this.getUxTemplateEditorLink(uxEditor),
    ];

    return [{
      label: Bs4I18N.getTT('MainWindow', 'MainWindow', 'Bs4MainWindow'),
      setUxTemplate: this.setUxTemplate,
      getUxTemplate: () => this.uxTemplate,
      types: [Bs4ReportCalendarPlanningUx.TYPE_BS4_THEME, Bs4ReportCalendarPlanningUx.TYPE_APPBAR, Bs4ReportCalendarPlanningUx.TYPE_INCOMING, Bs4ReportCalendarPlanningUx.TYPE_VERTICALMENU],
      Content: (props) => {        
        const {} = useStateUxTemplate([Bs4ReportCalendarPlanningUx.TYPE_BS4_THEME, Bs4ReportCalendarPlanningUx.TYPE_APPBAR, Bs4ReportCalendarPlanningUx.TYPE_INCOMING, Bs4ReportCalendarPlanningUx.TYPE_VERTICALMENU])
        const [expanded, setExpanded] = React.useState(eds[0].label);

        const handleChange = (panel) => (event, isExpanded) => {
          setExpanded(isExpanded ? panel : false);
        };

        return (
          <Box>
            {eds.map((ux, index) => {
              return (
                <UxAccordion 
                  key={index} 
                  label={ux.label} 
                  types={ux.types}
                  expanded={expanded} 
                  onChange={handleChange}
                  onReset={ux.onReset}
                >
                  <ux.Content />
                </UxAccordion>
              )
            })}
          </Box>
        )
      }, 
    }]
  }

  getUxTemplateEditorMain = (uxEditor) => {

    return { 
      label: Bs4I18N.getTT('MainWindow', 'MainWindow', 'Bs4MainWindow'),
      types: [Bs4ReportCalendarPlanningUx.TYPE_BS4_THEME],
      onReset: () => this.uxTemplate.body.Main.theme = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Main.theme)),
      Content: (props) => {
        const uxBody = this.uxTemplate.body.Main;
        const type = Bs4ReportCalendarPlanningUx.TYPE_BS4_THEME;
        const {} = useStateUxTemplate(type);

        //success info error
        
        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <uxEditor.ViewCssColor types={type} value={uxBody.theme} name='primary'/>
            <uxEditor.ViewCssColor types={type} value={uxBody.theme} name='secondary'/>
            
            <uxEditor.ViewCssColor types={type} value={uxBody.theme} name='info'/>
            <uxEditor.ViewCssColor types={type} value={uxBody.theme} name='success'/>
            <uxEditor.ViewCssColor types={type} value={uxBody.theme} name='warning'/>
            <uxEditor.ViewCssColor types={type} value={uxBody.theme} name='error'/>

            <uxEditor.ViewCssColor types={type} value={uxBody.theme} name='backgroundColor'/>
            <uxEditor.ViewCssNumber types={type} value={uxBody.theme} name='borderRadius'/>
            <uxEditor.ViewCssNumber types={type} value={uxBody.theme} name='spacing'/>
    
            <uxEditor.ViewCssSelect types={type} value={uxBody.theme} name='inputVariant' options={['filled', 'outlined', 'standard']} />
            <uxEditor.ViewCssSelect types={type} value={uxBody.theme} name='inputSize' options={['small', 'medium']}/>
            <uxEditor.ViewCssSelect types={type} value={uxBody.theme} name='inputMargin' options={['normal', 'dense', 'none']}/>
    
            <uxEditor.ViewCssSelect types={type} value={uxBody.theme} name='buttonVariant' options={['contained', 'outlined', 'text']}/>
            <uxEditor.ViewCssSelect types={type} value={uxBody.theme} name='buttonSize' options={['small', 'medium', 'large']}/>      
          </Box>
        );
      },
    };
  }

  getUxTemplateEditorBs4AppBar = (uxEditor) => {    

    return {
      label: Bs4I18N.getTT('AppBar', 'AppBar', 'Bs4MainWindow'),
      types: [Bs4ReportCalendarPlanningUx.TYPE_APPBAR],
      onReset: () => {
        this.uxTemplate.body.AppBar = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.AppBar));
      },
      Content: (props) => {
        const uxBody = this.uxTemplate.body.AppBar;
        const type = Bs4ReportCalendarPlanningUx.TYPE_APPBAR;
        const {} = useStateUxTemplate(type);
        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='color'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='backgroundColor'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='borderColor'/>
            </Stack>                                  

            <uxEditor.ViewCssShadow types={type} value={uxBody.box} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='borderWidth'/>

            <uxEditor.ViewCssText types={type} value={uxBody.box} name='height'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='padding'/>             

            <uxEditor.ViewCssText types={type} value={uxBody.logo} name='padding' title='Logo padding'/>
            <uxEditor.ViewCssText types={type} value={uxBody.logo} name='margin' title='Logo margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.logo} name='borderRadius' title='Logo borderRadius'/>

            {/* <uxEditor.ViewCssText types={type} value={uxBody.incoming} name='fontSize' title='incoming - fontSize'/>
            <uxEditor.ViewCssNumber types={type} value={uxBody.incoming} name='scale' title='incoming - scale'/>
            <uxEditor.ViewCssNumber types={type} value={uxBody.incoming} name='spacing' title='incoming - spacing'/>             */}
            {/* <uxEditor.ViewCssSelect types={type} value={uxBody.incoming} name='fontWeight'options={['100', '300', '400', '900']}/> */}
          </Box> 
        );
      },
    };
  }

  getUxTemplateEditorBs4Incoming = (uxEditor) => {    

    return {
      label: Bs4I18N.getTT('Incoming', 'Incoming', 'Bs4MainWindow'),
      types: [Bs4ReportCalendarPlanningUx.TYPE_INCOMING],
      onReset: () => {
        this.uxTemplate.body.AppBar = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.AppBar));
      },
      Content: (props) => {
        const uxBody = this.uxTemplate.body.AppBar;
        const type = Bs4ReportCalendarPlanningUx.TYPE_INCOMING;
        const {} = useStateUxTemplate(type);

        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            {/* <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='color'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='backgroundColor'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='borderColor'/>
            </Stack>                                   */}

            {/* <uxEditor.ViewCssShadow types={type} value={uxBody.box} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='borderWidth'/>

            <uxEditor.ViewCssText types={type} value={uxBody.box} name='height'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='padding'/>             

            <uxEditor.ViewCssText types={type} value={uxBody.logo} name='padding' title='Logo padding'/>
            <uxEditor.ViewCssText types={type} value={uxBody.logo} name='margin' title='Logo margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.logo} name='borderRadius' title='Logo borderRadius'/> */}
            
            <uxEditor.ViewCssText types={type} value={uxBody.incoming} name='fontSize'/>
            <uxEditor.ViewCssNumber types={type} value={uxBody.incoming} name='scale'/>
            <uxEditor.ViewCssNumber types={type} value={uxBody.incoming} name='spacing'/>
            {/* <uxEditor.ViewCssSelect types={type} value={uxBody.incoming} name='fontWeight'options={['100', '300', '400', '900']}/> */}
          </Box> 
        );
      },
    };
  }

  getUxTemplateEditorBs4VerticalMenu = (uxEditor) => {

    return {
      label: Bs4I18N.getTT('VerticalMenu', 'VerticalMenu', 'Bs4MainWindow'),
      onReset: () => this.uxTemplate.body.VerticalMenu = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.VerticalMenu)),
      Content: (props) => {
        const uxBody = this.uxTemplate.body.VerticalMenu;
        const type = Bs4ReportCalendarPlanningUx.TYPE_VERTICALMENU;
        const {} = useStateUxTemplate(type);

        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <uxEditor.ViewCssCheckbox types={type} value={uxBody} name='divider'/>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='color'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='backgroundColor'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='borderColor'/>
            </Stack>                                  

            <uxEditor.ViewCssShadow types={type} value={uxBody.box} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='borderWidth'/>

            <uxEditor.ViewCssText types={type} value={uxBody.box} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='padding'/>             

            <uxEditor.ViewCssNumber inputProps={{step: 0.05, min: 0, max: 1}} types={type} value={uxBody.text} name='main' title='text color'/>
            <uxEditor.ViewCssNumber inputProps={{step: 0.05, min: 0, max: 1}} types={type} value={uxBody.text} name='hover'/>
            <uxEditor.ViewCssNumber inputProps={{step: 0.05, min: 0, max: 1}} types={type} value={uxBody.text} name='selected'/>

            <uxEditor.ViewCssText  types={type} value={uxBody.scrollbar} name='width'/>
            <uxEditor.ViewCssText  types={type} value={uxBody.scrollbar} name='trackBorderRadius'/>
            <uxEditor.ViewCssColor types={type} value={uxBody.scrollbar} name='trackBackground'/>
            <uxEditor.ViewCssColor types={type} value={uxBody.scrollbar} name='trackBackgroundHover'/>
            <uxEditor.ViewCssColor types={type} value={uxBody.scrollbar} name='thumbBackground'/>
            <uxEditor.ViewCssColor types={type} value={uxBody.scrollbar} name='thumbBackgroundHover'/>           
          </Box>
        );
      },
    };
  }

  getUxTemplateEditorBs4VerticalMenuOptions = (uxEditor) => {

    return {
      label: Bs4I18N.getTT('Vertical menu mptions', 'Vertical menu mptions', 'Bs4MainWindow'),
      onReset: () => this.uxTemplate.body.VerticalMenuOptions = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.VerticalMenuOptions)),
      Content: (props) => {
        const uxBody = this.uxTemplate.body.VerticalMenuOptions;
        const type = Bs4ReportCalendarPlanningUx.TYPE_VERTICALMENU_OPTIONS;
        const {} = useStateUxTemplate(type);

        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <uxEditor.ViewCssCheckbox types={type} value={uxBody} name='divider'/>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='color'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='backgroundColor'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='borderColor'/>
            </Stack>                                  

            <uxEditor.ViewCssShadow types={type} value={uxBody.box} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='borderWidth'/>

            <uxEditor.ViewCssText types={type} value={uxBody.box} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='padding'/>             

            <uxEditor.ViewCssNumber inputProps={{step: 0.05, min: 0, max: 1}} types={type} value={uxBody.text} name='main' title='text color'/>
            <uxEditor.ViewCssNumber inputProps={{step: 0.05, min: 0, max: 1}} types={type} value={uxBody.text} name='hover'/>
            <uxEditor.ViewCssNumber inputProps={{step: 0.05, min: 0, max: 1}} types={type} value={uxBody.text} name='selected'/>

            <uxEditor.ViewCssText  types={type} value={uxBody.scrollbar} name='width'/>
            <uxEditor.ViewCssText  types={type} value={uxBody.scrollbar} name='trackBorderRadius'/>
            <uxEditor.ViewCssColor types={type} value={uxBody.scrollbar} name='trackBackground'/>
            <uxEditor.ViewCssColor types={type} value={uxBody.scrollbar} name='trackBackgroundHover'/>
            <uxEditor.ViewCssColor types={type} value={uxBody.scrollbar} name='thumbBackground'/>
            <uxEditor.ViewCssColor types={type} value={uxBody.scrollbar} name='thumbBackgroundHover'/>           
          </Box>
        );
      },
    };
  }

  getUxTemplateEditorLink = (uxEditor) => {

    return {
      label: Bs4I18N.getTT('<a>', '<a>', 'Bs4MainWindow'),
      onReset: () => this.uxTemplate.body.VerticalMenu = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Link)),
      Content: (props) => {
        const uxBody = this.uxTemplate.body.Link;
        const type = Bs4ReportCalendarPlanningUx.TYPE_A_LINK;
        const {} = useStateUxTemplate(type);
        return (
          <Box display='flex' flexDirection='column' p={1.5}>

            <Typography sx={{pt: 1}} variant='h6'>{'<a>'}</Typography>
            <uxEditor.ViewCssColor types={type} value={uxBody.a} name='color'/>
            <uxEditor.ViewCssText types={type} value={uxBody.a} name='fontWeight'/>
            <uxEditor.ViewCssText types={type} value={uxBody.a} name='textDecoration'/>

            <Typography sx={{pt: 1}} variant='h6'>{'<a>link'}</Typography>
            <uxEditor.ViewCssColor types={type} value={uxBody.link} name='color'/>
            <uxEditor.ViewCssText types={type} value={uxBody.link} name='fontWeight'/>
            <uxEditor.ViewCssText types={type} value={uxBody.link} name='textDecoration'/>

            <Typography sx={{pt: 1}} variant='h6'>{'<a>visited'}</Typography>
            <uxEditor.ViewCssColor types={type} value={uxBody.visited} name='color'/>
            <uxEditor.ViewCssText types={type} value={uxBody.visited} name='fontWeight'/>
            <uxEditor.ViewCssText types={type} value={uxBody.visited} name='textDecoration'/>

            <Typography sx={{pt: 1}} variant='h6'>{'<a>hover'}</Typography>
            <uxEditor.ViewCssColor types={type} value={uxBody.hover} name='color'/>
            <uxEditor.ViewCssText types={type} value={uxBody.hover} name='fontWeight'/>
            <uxEditor.ViewCssText types={type} value={uxBody.hover} name='textDecoration'/>
          </Box>
        );
      },
    };
  }
}